export default function Section2() {
    return (
        <div className="w-full Section2">
            <div className="flex items-center justify-center w-full section2-container">
                <div className="text-center w-[90%] md:w-[70%] lg:w-[60%] mx-auto">

                    <h1 className="mt-[40px] mb-[1%] md:mb-0 text-[24px] leading-[29px] md:text-[40px] font-bold md:leading-[48px] text-[#151515]">
                        Conversion Rate Optimization (CRO) Services in Dubai & Across the UAE
                    </h1>
                    <p className="text-[#151515] font-semibold text-[18px] md:text-[20px] mt-4">
                        Turn More Visitors into Paying Customers with Data-Driven CRO Strategies for UAE Businesses.
                    </p>
                    <p className="leading-[22px] text-[#373737] text-base font-open max-w-[700px] mx-auto mt-10">
                        At Mean3, we help you get more from your website traffic. As a trusted CRO agency in Dubai, we specialize in increasing conversions, whether that means more purchases, more inquiries, or more calls. Our data-driven approach identifies where visitors drop off, what stops them from taking action, and how to fix it. We make sure every click, scroll, and interaction leads to measurable results and business growth.
                    </p>
                </div>
            </div>

            <div className="line my-[55px] md:my-[4%] mx-auto w-[70%] md:w-[61%] shadow-line h-2 rounded-[100%]"></div>
        </div>
    );
}
